import Terms from 'pages/Terms'

import CombinedClosureWV from '../pages/close-account-v3/combined-closure'
import EarlyCloseAccountWV from '../pages/close-account-v3/early/index'
import InvestCloseAccountWV from '../pages/close-account-v3/invest'
import LaterCloseAccountWV from '../pages/close-account-v3/later'
import SpendCloseAccountWV from '../pages/close-account-v3/spend'
import InvestmentDisclosure from '../pages/early/investment-disclosure'
import { LinkInstitutionRedirect } from '../pages/settings/linked-accounts/link/redirect'
import MySubscription from '../pages/settings/my-subscription'
import DowngradeWV from '../pages/settings/my-subscription/downgrade'
import UpgradeSuccessWV from '../pages/settings/my-subscription/tier-subscription-center/upgrade-success'
import DirectDepositOnline from '../pages/spend/direct-deposit/online/web-view'
import DirectDepositPDF from '../pages/spend/direct-deposit/pdf/web-view'
import DirectDepositSearch from '../pages/spend/direct-deposit/search/web-view'
import DirectDepositSubmittable from '../pages/spend/direct-deposit/submittable/web-view'
import { withWebviewLifecycle } from '../utils/with-webview-lifecycle'

const DirectDepositPDFWebView = withWebviewLifecycle(DirectDepositPDF)
const DirectDepositSearchWebView = withWebviewLifecycle(DirectDepositSearch)
const DirectDepositOnlineWebView = withWebviewLifecycle(DirectDepositOnline)
const DirectDepositSubmittableWebView = withWebviewLifecycle(
  DirectDepositSubmittable,
)

const MySubscriptionWebview = withWebviewLifecycle(MySubscription)
const SpendCloseAccount = withWebviewLifecycle(SpendCloseAccountWV)
const EarlyCloseAccount = withWebviewLifecycle(EarlyCloseAccountWV)
const LaterCloseAccount = withWebviewLifecycle(LaterCloseAccountWV)
const InvestCloseAccount = withWebviewLifecycle(InvestCloseAccountWV)
const CombinedClosure = withWebviewLifecycle(CombinedClosureWV)
const InvestmentDisclosureWebView = withWebviewLifecycle(InvestmentDisclosure)

// Bypassing auth route requires update to
// src/config/apollo.tsx -> enhance (local)
// update to web-roller-lambda .env files (staging/prod)
export const routes = [
  {
    path: '/wv/spend/direct-deposit/pdf',
    component: DirectDepositPDFWebView,
  },
  {
    path: '/wv/spend/direct-deposit/search',
    component: DirectDepositSearchWebView,
  },
  {
    path: '/wv/spend/direct-deposit/online',
    component: DirectDepositOnlineWebView,
  },
  {
    path: '/wv/spend/direct-deposit/submittable',
    component: DirectDepositSubmittableWebView,
  },
  {
    path: '/wv/close-account/early',
    component: EarlyCloseAccount,
  },

  {
    path: '/wv/close-account/later',
    component: LaterCloseAccount,
  },
  {
    path: '/wv/close-account/spend',
    component: SpendCloseAccount,
  },
  { path: '/wv/close-account/invest', component: InvestCloseAccount },
  { path: '/wv/cancel-subscription', component: CombinedClosure },

  {
    path: '/wv/my-subscription/downgrade',
    component: DowngradeWV,
  },
  {
    path: '/wv/my-subscription',
    component: MySubscriptionWebview,
  },
  {
    path: '/wv/upgrade-success',
    component: UpgradeSuccessWV,
  },
  {
    path: '/wv/investment-disclosure',
    component: InvestmentDisclosureWebView,
  },
  {
    path: '/wv/link/redirect',
    component: LinkInstitutionRedirect,
  },
  {
    path: '/terms',
    component: Terms,
  },
]

export default routes
